import { BaseModel } from '../common/base-model/base-model';
import { ServiceGroupServices } from '../service-group-services/service-group-services';

export class ServiceGroup extends BaseModel {
  constructor(
    public override id?: string,
    public name?: string,
    public color?: string,
    public isActive?: boolean,
    public service_groups_services?: ServiceGroupServices[],
    public owner_root_entity_id?: string,
    public target_entity_id?: string,
  ) {
    super();
  }

  static fromJson(jsonData: any): ServiceGroup {
    const serviceGroup = Object.assign(new ServiceGroup(), jsonData);

    if (jsonData.isActive !== undefined) {
      serviceGroup.isActive =
        jsonData.isActive === 1 ||
        jsonData.isActive === true ||
        jsonData.isActive === 'true' ||
        jsonData.status === 'ACTIVE';
    }

    if (
      jsonData.service_groups_services &&
      Array.isArray(jsonData.service_groups_services)
    ) {
      serviceGroup.service_groups_services =
        jsonData.service_groups_services.map((item: any) =>
          ServiceGroupServices.fromJson(item),
        );
    } else if (
      jsonData.services &&
      Array.isArray(jsonData.services) &&
      jsonData.services[0]?.serviceId
    ) {
      serviceGroup.service_groups_services = jsonData.services.map(
        (item: any) => ServiceGroupServices.fromJson(item),
      );
    }

    return serviceGroup;
  }
}
